import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { AdditionalServicesList } from "@features/AdditionalServices/components/AdditionalServicesList/AdditionalServicesList";
import { ChevronRightIcon } from "@components/icons";
import { Link } from "@components/Link/Link";
import { usePromotedAdditionalServicesQuery } from "@services/additional-services/queries";

export const PromotedAdditionalServicesContent: React.FC = () => {
  const { t } = useTranslation();
  const { data: services = [], isLoading } =
    usePromotedAdditionalServicesQuery();
  const { pathname, search } = useLocation();

  return (
    !isLoading &&
    !!services.length && (
      <div className="flex flex-col gap-5">
        <div className="flex items-center justify-between">
          <h4>{t("promotedAdditonalServices.title")}</h4>
          <Link to="/services">
            <h5 className="flex items-center text-base-black">
              {t("promotedAdditonalServices.actions.allServices")}{" "}
              <ChevronRightIcon className="size-4" />
            </h5>
          </Link>
        </div>
        <AdditionalServicesList
          services={services}
          returnPath={pathname + search}
          limit
        />
      </div>
    )
  );
};
